export const formatDuration = (durationMs?: number | null): string => {
  if (!durationMs) return '0s'

  const totalSeconds = Math.max(0, Math.floor(durationMs / 1000))
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return [
    hours ? `${hours}h` : null,
    minutes ? `${minutes}m` : null,
    seconds || (!hours && !minutes) ? `${seconds}s` : null,
  ]
    .filter(Boolean)
    .join(' ')
}

export const formatHours = (hours: number): string => {
  if (hours <= 0) return '0h'
  if (hours < 1) return `${Math.round(hours * 60)}m`
  const whole = Math.floor(hours)
  const minutes = Math.round((hours - whole) * 60)
  if (!minutes) return `${whole}h`
  return `${whole}h ${minutes}m`
}

export const formatTickLabel = (hour: number): string => {
  if (hour === 0) return '12a'
  if (hour === 12) return '12p'
  return hour < 12 ? `${hour}a` : `${hour - 12}p`
}
